module.exports = __webpack_public_path__ + "images/emoji/family.0e5b904e38f0c9e65d90.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/family.png
// module id = JBER
// module chunks = 2